import { useTheme } from "@mui/system";

export default function ExaminationIcon ({size = 40}) {
  const theme = useTheme();

  const baseWidth = 40;
  const baseHeight = 43;

  const height = (baseHeight * size) / baseWidth;

  return (
    <svg 
      width={baseWidth}
      height={height} 
      viewBox="0 0 40 43" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M40 14.3076C40 11.1115 37.385 8.49646 34.1889 8.49646C30.9927 8.49646 28.3777 11.1115 28.3777 14.3076C28.3777 16.8258 29.9274 18.9565 32.155 19.7313V31.6442C32.155 38.5207 25.1816 39.0049 23.0509 39.0049C20.9201 39.0049 13.9467 38.5207 13.9467 31.6442V27.0921C19.4673 26.2204 24.0194 22.0558 24.0194 17.6006V5.59089C24.0194 3.55699 22.8571 1.7168 21.1138 0.84513C19.5642 0.0703116 18.1114 -0.123394 16.9492 0.360868C15.8838 0.748277 15.3995 1.81365 15.7869 2.87903C16.1743 3.9444 17.3366 4.52552 18.3051 4.13811C18.4019 4.13811 18.6925 4.13811 19.3705 4.42867C19.7579 4.62237 20.0484 5.10663 20.0484 5.59089V17.5037C20.0484 19.7313 16.6586 23.1212 12.0097 23.1212C7.36078 23.1212 3.97094 19.7313 3.97094 17.5037V5.59089C3.97094 5.10663 4.2615 4.62237 4.64891 4.42867C5.23002 4.13811 5.61743 4.13811 5.71429 4.13811C6.77966 4.52552 7.94189 3.9444 8.3293 2.87903C8.71671 1.81365 8.13559 0.651425 7.07022 0.264016C5.81114 -0.220246 4.35835 -0.0265406 2.90557 0.748278C1.06538 1.61995 0 3.46014 0 5.49404V17.4069C0 21.9589 4.55206 26.0267 10.0726 26.8984V31.4505C10.0726 39.2955 16.6586 42.879 23.1477 42.879C29.6368 42.879 36.2228 39.3923 36.2228 31.4505V19.7313C38.3535 18.9565 40 16.8258 40 14.3076ZM34.1889 12.4674C35.1574 12.4674 36.0291 13.2422 36.0291 14.3076C36.0291 15.2761 35.2542 16.1478 34.1889 16.1478C33.2203 16.1478 32.3487 15.373 32.3487 14.3076C32.3487 13.3391 33.1235 12.4674 34.1889 12.4674Z"
        fill={theme.palette.rgd.primary}
      />
    </svg>
  )
}